<template>
    <div v-if="quote.HasError != true" :class="{ 'finance-quote__quote': true, 'personal': modified }">
        <div class="finance-quote__quote-key"><span class="value">{{ numberOfPayments }}</span> Monthly Payments</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.AllInclusiveRegularPayment, 2) }}</div>

        <template v-if="modified && depositContribution > 0">
            <div class="finance-quote__quote-key">Deposit Contribution</div>
            <div class="finance-quote__quote-value">&pound;{{ numberFormat(depositContribution, 2) }}</div>
        </template>
        <template v-else-if="depositContribution > 0">
            <div class="finance-quote__quote-key">Deposit Contribution</div>
            <div class="finance-quote__quote-value">&pound;{{ numberFormat(depositContribution, 2) }}</div>
        </template>

        <div class="finance-quote__quote-key">Customer Cash Deposit</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.CashDeposit, 2) }}</div>

        <div v-if="quote.Quote.PartExchange" class="finance-quote__quote-key">Part-exchange Guide Price</div>
        <div v-if="quote.Quote.PartExchange" class="finance-quote__quote-value">&pound;{{
            numberFormat(quote.Quote.PartExchange, 2) }}
        </div>

        <template v-if="vehiclePriceIncludesVAT">
            <div class="finance-quote__quote-key">Vehicle Price inc VAT</div>
            <div class="finance-quote__quote-value">&pound;{{ numberFormat(quotePrice, 2) }}</div>
            <div class="finance-quote__quote-key">Vehicle Selling Price</div>
            <div class="finance-quote__quote-value">&pound;{{ numberFormat(cashPrice, 2) }}</div>
        </template>
        <template v-else>
            <div class="finance-quote__quote-key">Vehicle Price</div>
            <div class="finance-quote__quote-value">&pound;{{ numberFormat(quotePrice, 2) }}</div>
        </template>

        <div class="finance-quote__quote-key">Amount Financed</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.Balance, 2) }}</div>

        <div class="finance-quote__quote-key">Optional Final Payment To Buy</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(finalPayment, 2) }}</div>

        <div class="finance-quote__quote-key">Credit Facility Fee<br /><span class="smallText">Payable With 1st
                Payment</span></div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(fees, 2) }}</div>

        <div class="finance-quote__quote-key">Term Of Agreement</div>
        <div class="finance-quote__quote-value">{{ quote.Quote.Term }} months</div>

        <div class="finance-quote__quote-key">Total Charge For Credit</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.TotalChargeForCredit, 2) }}</div>

        <div class="finance-quote__quote-key">Total Amount Of Credit</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.AmountOfCredit, 2) }}</div>

        <div class="finance-quote__quote-key">Total Amount Payable</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.TotalAmountPayable, 2) }}</div>

        <div class="finance-quote__quote-key">Fixed Rate of Interest</div>
        <div class="finance-quote__quote-value"> {{ numberFormat(quote.Quote.RateOfInterest, 2) }} %</div>

        <div v-if="modified" class="finance-quote__quote-key">APR</div>
        <div v-else class="finance-quote__quote-key">Representative APR</div>
        <div class="finance-quote__quote-value"> {{ numberFormat(quote.Quote.Apr, 2) }} % APR</div>

        <div class="finance-quote__quote-key">Excess Mileage Charge</div>
        <div class="finance-quote__quote-value"> {{ numberFormat(quote.Quote.ExcessMileageRate, 0) }} pence per mile</div>

        <div class="finance-quote__quote-key">Annual Mileage</div>
        <div class="finance-quote__quote-value"> {{ numberFormat(quote.Quote.AnnualMileage, 0) }} miles</div>
    </div>
</template>

<script>
import numberFormat from '../../../api/NumberFormat';

export default {
    props: {
        quote: {
            required: true,
        },
        loading: {
            required: true,
        },
        repExample: {
            default: false,
        },
        vehicle: {
        }
    },
    methods: {
        numberFormat(num, decimals) {
            return numberFormat(num, decimals);
        },
    },
    computed: {
        cashPrice() {
            return parseFloat(this.vehicle.vat_price);
        },
        quotePrice() {
            return parseFloat(this.quote.Quote.CashPrice);
        },
        vehiclePriceIncludesVAT() {
            if (this.cashPrice == this.quotePrice) {
                return false;
            }
            // Add a bit of tolerance into it just for rounding errors or something
            if (((this.cashPrice * 1.2) - this.quotePrice) <= 1) {
                return true;
            }
            return false;
        },
        modified() {
            if (this.repExample) {
                return false;
            }
            return this.$store.state.FinanceParameters.modified;
        },
        numberOfPayments() {
            if (this.quote.Quote.Payments.length == 0) {
                return 0;
            }
            let numberOfPayments = 0;
            for (let index = 0, len = (this.quote.Quote.Payments.length - 1); index < len; index++) {
                numberOfPayments = numberOfPayments + parseFloat(this.quote.Quote.Payments[index].NumberOfPayments);
            }
            return numberOfPayments;
        },
        finalPayment() {
            if (typeof this.quote.Quote.Payments[(this.quote.Quote.Payments.length - 1)] !== 'undefined') {
                return parseFloat(this.quote.Quote.Payments[(this.quote.Quote.Payments.length - 1)].Amount);
            }
            return 0;
        },
        fees() {
            if (typeof this.quote.Quote.Fees[0] !== 'undefined') {
                return parseFloat(this.quote.Quote.Fees[0].Amount);
            }
            return 0;
        },
        inSalesEvent(){
            if(this.vehicle){
                return this.vehicle.extra_data.includes('sale-event');
            }else {
                return false
            }
        },
        depositContribution() {
            if (typeof this.quote.Quote.DepositContribution !== 'undefined') {
                return parseFloat(this.quote.Quote.DepositContribution);
            }
            if (typeof this.quote.Quote.DepositContributions == 'undefined') {
                return 0.00;
            }

            let depCon = 0.00;
            for (let index = 0, len = this.quote.Quote.DepositContributions; index < len; index++) {
                const financeNotification = this.quote.Quote.DepositContributions[index];
                if (typeof financeNotification.Amount == 'undefined') {
                    continue;
                }
                depCon += parseFloat(financeNotification.Amount);
            }

            return depCon;
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/redesign/variables";

.finance-quote {
    &__quote {
        display: grid;
        grid-template-columns: minmax(0, 2fr) minmax(0, 125px);
        font-size: 16px;
        gap: 5px;
    }

    &__quote-key {
        grid-column: 1 / 2;
        text-align: left;
    }

    &__quote-value {
        grid-column: 2 / 3;
        font-weight: 800;
        text-align: right;
        color: #0E3B85;
    }
}
</style>